import * as $ from "jquery"

const Visa: CreditCardTypeParams = {
	name: "Visa",
	code: 'vis',
	pattern: /^4/,
	structure: [4, 4, 4, 4],
	cvv: 3
}

const MasterCard: CreditCardTypeParams = {
	name: "MasterCard",
	code: 'mcd',
	pattern: /^5[012345]/,
	structure: [4, 4, 4, 4],
	cvv: 3
}

const DinersClub: CreditCardTypeParams = {
	name: "DinersClub",
	code: 'diner',
	pattern: /^3(0[0123459]|6|8|9)/,
	structure: [4, 6, 4, 0],
	cvv: 3
}

const Amex: CreditCardTypeParams = {
	name: "AmEx",
	code: 'amex',
	pattern: /^3[47]/,
	structure: [4, 6, 5, 0],
	cvv: 4
}

const putCursorAtEnd = function (query: JQuery) {
	return query.each(function (this: HTMLElement) {
		const that = this
		if (that instanceof HTMLInputElement) {
			$(that).focus()
			if (that.setSelectionRange) {
				const len = $(that).val().length * 2
				that.setSelectionRange(len, len)
			} else {
				$(that).val($(that).val())
			}
			that.scrollTop = 999999
		}
	})
}

export const checkCreditCard = (cardnumber: string, cardname: string): boolean => {

	// Array to hold the permitted card characteristics
	var cards = [];

	// Define the cards we support. You may add addtional card types as follows.

	//  Name:         As in the selection box of the form - must be same as user's
	//  Length:       List of possible valid lengths of the card number for the card
	//  prefixes:     List of possible prefixes for the card
	//  checkdigit:   Boolean to say whether there is a check digit

	cards [0] = {name: "Visa",
		length: "13,16",
		prefixes: "4",
		checkdigit: true};
	cards [1] = {name: "MasterCard",
		length: "16",
		prefixes: "51,52,53,54,55",
		checkdigit: true};
	cards [2] = {name: "DinersClub",
		length: "14,16",
		prefixes: "36,38,54,55",
		checkdigit: true};
	cards [3] = {name: "CarteBlanche",
		length: "14",
		prefixes: "300,301,302,303,304,305",
		checkdigit: true};
	cards [4] = {name: "AmEx",
		length: "15",
		prefixes: "34,37",
		checkdigit: true};
	cards [5] = {name: "Discover",
		length: "16",
		prefixes: "6011,622,64,65",
		checkdigit: true};
	cards [6] = {name: "JCB",
		length: "16",
		prefixes: "35",
		checkdigit: true};
	cards [7] = {name: "enRoute",
		length: "15",
		prefixes: "2014,2149",
		checkdigit: true};
	cards [8] = {name: "Solo",
		length: "16,18,19",
		prefixes: "6334,6767",
		checkdigit: true};
	cards [9] = {name: "Switch",
		length: "16,18,19",
		prefixes: "4903,4905,4911,4936,564182,633110,6333,6759",
		checkdigit: true};
	cards [10] = {name: "Maestro",
		length: "12,13,14,15,16,18,19",
		prefixes: "5018,5020,5038,6304,6759,6761,6762,6763",
		checkdigit: true};
	cards [11] = {name: "VisaElectron",
		length: "16",
		prefixes: "4026,417500,4508,4844,4913,4917",
		checkdigit: true};
	cards [12] = {name: "LaserCard",
		length: "16,17,18,19",
		prefixes: "6304,6706,6771,6709",
		checkdigit: true};

	// Establish card type
	var cardType = -1;
	for (var i=0; i<cards.length; i++) {

		// See if it is this card (ignoring the case of the string)
		if (cardname.toLowerCase () == cards[i].name.toLowerCase()) {
			cardType = i;
			break;
		}
	}

	// If card type not found, report an error
	if (cardType == -1) {
		window.ccErrorNo = 0;
		return false;
	}

	// Ensure that the user has provided a credit card number
	if (cardnumber.length == 0)  {
		window.ccErrorNo = 1;
		return false;
	}

	// Now remove any spaces from the credit card number
	cardnumber = cardnumber.replace (/\s/g, "");

	// Check that the number is numeric
	var cardNo = cardnumber
	var cardexp = /^[0-9]{13,19}$/;
	if (!cardexp.exec(cardNo))  {
		window.ccErrorNo = 2;
		return false;
	}

	// Now check the modulus 10 check digit - if required
	if (cards[cardType].checkdigit) {
		var checksum = 0;                                  // running checksum total
		var j = 1;                                         // takes value of 1 or 2

		// Process each digit one by one starting at the right
		var calc;
		for (i = cardNo.length - 1; i >= 0; i--) {

			// Extract the next digit and multiply by 1 or 2 on alternative digits.
			calc = Number(cardNo.charAt(i)) * j;

			// If the result is in two digits add 1 to the checksum total
			if (calc > 9) {
				checksum = checksum + 1;
				calc = calc - 10;
			}

			// Add the units element to the checksum total
			checksum = checksum + calc;

			// Switch the value of j
			if (j ==1) {j = 2} else {j = 1}
		}

		// All done - if checksum is divisible by 10, it is a valid modulus 10.
		// If not, report an error.
		if (checksum % 10 != 0)  {
			window.ccErrorNo = 3;
			return false;
		}
	}

	// Check it's not a spam number
	if (cardNo == '5490997771092064') {
		window.ccErrorNo = 5;
		return false;
	}

	// The following are the card-specific checks we undertake.
	var LengthValid = false;
	var PrefixValid = false;

	// We use these for holding the valid lengths and prefixes of a card type
	var lengths: number[] = []

	// Load an array with the valid prefixes for this card
	var prefix = cards[cardType].prefixes.split(",");

	// Now see if any of them match what we have in the card number
	for (i=0; i<prefix.length; i++) {
		var exp = new RegExp ("^" + prefix[i]);
		if (exp.test (cardNo)) PrefixValid = true;
	}

	// If it isn't a valid prefix there's no point at looking at the length
	if (!PrefixValid) {
		window. ccErrorNo = 3;
		return false;
	}

	// See if the length is valid for this card
	lengths = cards[cardType].length.split(",").map(n => Number.parseInt(n));
	for (j=0; j<lengths.length; j++) {
		if (cardNo.length == lengths[j]) LengthValid = true;
	}

	// See if all is OK by seeing if the length was valid. We only check the length if all else was
	// hunky dory.
	if (!LengthValid) {
		window.ccErrorNo = 4;
		return false;
	}

	// The credit card is in the required format.
	return true;
}

const initialiseCreditCardGroupFields = function (oldtype: CreditCardTypeParams, type: CreditCardTypeParams) {
	const full = $("[name='CreditCardNumberFull']")
	let current = 0
	const fulltext = full.val().replace(/[^0-9]/, "")
	const breakUpNumbers = function () {
		for (let i = 0; i < 4; i++) {
			const group = $("[name='CreditCardNumberGroup[" + i + "]']")
			const text = fulltext.slice(current, current + type.structure[i])
			group.val(text)
			current += type.structure[i]
		}
	}
	const focusNextGroup = function () {
		for (let i = 0; i < 4; i++) {
			const group = $("[name='CreditCardNumberGroup[" + i + "]']")
			if (group.val().length != group.prop('maxlength')) {
				group.focus()
				putCursorAtEnd(group)
				break
			}
		}
	}

	breakUpNumbers()
	focusNextGroup()
	callChangeTypeCallback(oldtype, type)
}

const setCardType = function (oldtype: CreditCardTypeParams, type: CreditCardTypeParams | null) {
	const full = $("[name='CreditCardNumberFull']")

	const showAllCreditCardIcons = function () {
		full.css('display', 'inline')
		full.focus()
		$("[name^='CreditCardNumberGroup']").css('display', 'none')
		$("[name|='cc-full']").css('display', 'inline')
		$("[name|='cc-grey']").css('display', 'none')
	}
	const hightlightSelectedTypeIcon = function (type: CreditCardTypeParams) {
		full.css('display', 'none')

		$("[name|='cc-full']").css('display', 'none')
		$("[name|='cc-grey']").css('display', 'inline')
		$("[name='cc-grey-" + type.code + "']").css('display', 'none')
		$("[name='cc-full-" + type.code + "']").css('display', 'inline')
	}
	const layoutGroupTextBoxes = function (type: CreditCardTypeParams) {
		for (let i = 0; i < 4; i++) {
			const group = $("[name='CreditCardNumberGroup[" + i + "]']")
			group.css('display', type.structure[i] > 0 ? 'inline' : 'none')
			group.prop('maxlength', type.structure[i])
			group.width((0.75 + type.structure[i] * 0.75) + "em")
		}
	}

	full.data('oldType', type)

	if (type == null) {
		showAllCreditCardIcons()
	} else {
		hightlightSelectedTypeIcon(type)
		layoutGroupTextBoxes(type)
		if (oldtype != type)
			initialiseCreditCardGroupFields(oldtype, type)
	}
}

const collateCreditCardNumber = function () {
	const full = $("[name='CreditCardNumberFull']")
	if (full.css('display') == 'none') {
		let string = '';
		for (let i = 0; i < 4; i++) {
			const group = $("[name='CreditCardNumberGroup[" + i + "]']")
			if (group.css('display') != 'none')
				string += group.val()
		}
		full.val(string)
	}
}

const detectType = function (cardNumber: string) {
	for (let i = 0; i < types.length; i++)
		if (types[i].pattern.test(cardNumber))
			return types[i]

	return null
}

const move = function(source: JQuery, direction: 'previous'|'next') {
	const destination = source.data(direction)

	if (destination == undefined)
		return true

	if (destination.css('display') != 'none') {
		destination.focus()
		return false
	}

	return true
}

const moveToPrevious = function (source: JQuery) {
	move(source, 'previous')

	return true
}

const moveToNext = function (source: JQuery) {
	if (source.val().length >= source.prop('maxlength'))
		return move(source, 'next')

	return true
}

type ChangeTypeCallback = (oldType: CreditCardTypeParams, newType: CreditCardTypeParams) => void
let callChangeTypeCallback: ChangeTypeCallback = function () {}

export let types: CreditCardTypeParams[] = [Visa, MasterCard, DinersClub, Amex] /* todo checkme */
export const setTypes = function (newTypes: CreditCardTypeParams[]) { types = newTypes }
//noinspection JSUnusedGlobalSymbols
export const setChangeTypeCallback = function (callback: ChangeTypeCallback) { callChangeTypeCallback = callback }

export const blur = function (event: JQueryKeyEventObject) {
	const target = $(event.target)
	target.data('oldLength', target.val().length)
}

export const keydown = function (event: JQueryKeyEventObject) {
	const target = $(event.target)

	target.data('oldLength', target.val().length)
	if (( [37, 38].indexOf(event.which) !== -1 && target.caret() == 0 ) || ( 8 == event.which && target.val().length == 0 ))
		return moveToPrevious(target)
	else if ([40, 39, 35].indexOf(event.which) !== -1 && target.caret() == target.val().length)
		return move(target, 'next')

	return true
}

export const creditCardType = function () {
	collateCreditCardNumber()
	const full = $("[name='CreditCardNumberFull']")
	const type = detectType(full.val())
	const oldType = full.data('oldType')

	return {old: oldType, new_: type}
}

export const keyup = function (event: JQueryKeyEventObject) {
	const type = creditCardType()
	setCardType(type.old, type.new_)

	const target = $(event.target)
	const data = target.data('oldLength')
	if (typeof( data ) == 'undefined' || target.val().length > data)
		moveToNext(target)
}

//noinspection JSUnusedGlobalSymbols
export const isCreditCardValid = function () {
	const type = creditCardType()

	return type.new_ != null && checkCreditCard($("[name='CreditCardNumberFull']").val(), type.new_.name)
}

//noinspection JSUnusedGlobalSymbols
export const isCreditCardCvvValid = function () {
	const params = getCreditCardParams()

	return params.cvv.length == requiredCvvDigits();
}

export const requiredCvvDigits = function () {
	const type = creditCardType()

	return type.new_ != null && type.new_.cvv != null ? type.new_.cvv : 3;
}

//noinspection JSUnusedGlobalSymbols
export const isCreditCardExpiryValid = function () {
	const params = getCreditCardParams()
	const date = new Date()

	const currentYear = date.getFullYear()
	const currentMonth = date.getMonth() + 1
	const suppliedYear = Number.parseInt(params.year);

	return suppliedYear > currentYear || (suppliedYear == currentYear && Number.parseInt(params.month) >= currentMonth )
}

export const getCreditCardParams = (): CreditCardParams => {
	const type = creditCardType().new_

	return {
		method: "CreditCard",
		cardType: type == null ? 'unknown' : type.code,
		number: $("[name='CreditCardNumberFull']").val(),
		month: $("[name='CreditCardExpiryMonth']").val(),
		year: $("[name='CreditCardExpiryYear']").val(),
		name: $("[name='CreditCardCardholderName']").val(),
		cvv: $("[name='CreditCardNumberCVV']").val()
	}
}

export var ccErrors: string[] = []

ccErrors [0] = "Unknown card type";
ccErrors [1] = "No card number provided";
ccErrors [2] = "Credit card number is in invalid format";
ccErrors [3] = "Credit card number is invalid";
ccErrors [4] = "Credit card number has an inappropriate number of digits";
ccErrors [5] = "Warning! This credit card number is associated with a scam attempt";




// WEBPACK FOOTER //
// ./src/paymentgateway/credit-card.ts